import {
    IBACPredesign,
    TDefaultPredesignValues,
} from '@/src/modules/build-a-card/types'
import { NextRouter } from 'next/router'
import {
    BRAND_PAGE,
    PARTNER_PATH,
    PG_PLUS_BUILD_PAGE,
    VIRTUAL_VISA_PAGE,
} from '@/src/modules/pg-plus/constants'

function determineDefaultImageValues(
    router: NextRouter,
    predesigns: IBACPredesign[]
): TDefaultPredesignValues {
    const isValidPage: boolean =
        router.pathname.includes(BRAND_PAGE) ||
        router.pathname.includes(PG_PLUS_BUILD_PAGE) ||
        router.pathname.includes(PARTNER_PATH) ||
        router.pathname.includes(VIRTUAL_VISA_PAGE)

    // only determine default values if in pg+ flow
    if (!isValidPage || predesigns.length === 0) {
        return {
            default_image_uuid: '',
            default_design_name: '',
            default_preview_image: '',
        }
    }

    // check if a design url param has been passed in
    // if there is, use it as the default predesign image
    const designParam = String(router?.query?.design ?? '')
    const defaultDesignName = designParam?.replace(/_+/g, ' ')

    const { preview_image_url, uuid, design_name } =
        predesigns?.find((design: IBACPredesign) => {
            return design.design_name == defaultDesignName
        }) ?? predesigns[0]

    return {
        default_preview_image: preview_image_url,
        default_design_name: design_name,
        default_image_uuid: uuid,
    }
}

export default determineDefaultImageValues
